import { AppRoutes } from '@/config/routes'
import { type Chain } from '@safe-global/store/gateway/AUTO_GENERATED/chains'
import { type NextRouter } from 'next/router'
import { useCallback } from 'react'
import { useIsSpaceRoute } from '@/hooks/useIsSpaceRoute'
import { useUrlSpaceId, withSpaceId } from '@/hooks/useUrlSpaceId'

/**
 * Navigate to the dashboard when selecting a safe on the welcome page,
 * navigate to the history when selecting a safe on a single tx page,
 * otherwise keep the current route
 */
export const useGetHref = (router: NextRouter) => {
  const isSpacePage = useIsSpaceRoute()
  const isWelcomePage = router.pathname === AppRoutes.welcome.accounts
  const isSingleTxPage = router.pathname === AppRoutes.transactions.tx
  const spaceId = useUrlSpaceId()

  return useCallback(
    (chain: Chain, address: string) => {
      return {
        pathname:
          isWelcomePage || isSpacePage
            ? AppRoutes.home
            : isSingleTxPage
              ? AppRoutes.transactions.history
              : router.pathname,
        // A Workspace page keeps only its Workspace; a Safe page keeps its whole query, spaceId included
        query: isSpacePage
          ? withSpaceId({ safe: `${chain.shortName}:${address}` }, spaceId)
          : { ...router.query, safe: `${chain.shortName}:${address}` },
      }
    },
    [isSingleTxPage, isWelcomePage, isSpacePage, spaceId, router.pathname, router.query],
  )
}
